/**
 * @module cms
 * @description A list of content collection types for Synotech CMS
 */

export const cms = [
	'insights',
	'pages',
	'users',
	'categories',
	'components',
	'clients',
	'downloads',
	'elements',
	'downloads',
	'widgets',
	'faqs',
	'events',
	'galleries',
	'heros',
	'jobs',
	'media',
	'prompts',
	'statistics',
	'subscribers',
	'taxonomies',
	'teams',
	'settings',
] as const;
export type Cms = (typeof cms)[number];
